import React from "react";
import { Bell, CloudSun, Compass, Navigation, ShieldCheck } from "lucide-react";

const features = [
  [CloudSun, "Quick weather access", "Open Marstick marine weather quickly from your browser."],
  [Navigation, "Marine forecast shortcut", "Jump straight to forecasts and sailing conditions."],
  [ShieldCheck, "Safety alerts shortcut", "Reach safety and preparedness tools faster."],
  [Compass, "Route/weather tools", "Launch route and weather decision tools."],
  [Bell, "Optional notifications", "Only when supported and approved by the user."],
];

export default function ExtensionFeatureGrid() {
  return (
    <section className="mt-10">
      <h2 className="text-2xl font-black">What does the extension do?</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {features.map(([Icon, title, text]) => <div key={title} className="rounded-[1.5rem] border border-border bg-card p-5"><Icon className="h-6 w-6 text-primary" /><h3 className="mt-3 font-black">{title}</h3><p className="mt-2 text-sm leading-6 text-muted-foreground">{text}</p></div>)}
      </div>
    </section>
  );
}